import Image from "next/image";

import { PropsWithChildren } from "react";
import styles from "./gallery.module.css";

const Gallery = ({
  url,
  alt,
  children,
  secondImage
}: PropsWithChildren<{
  url: string;
  alt?: string;
  secondImage?: {
    uri?: string;
    alt?: string;
  };
}>) => {
  return (
    <div className={styles.root}>
      <div className={styles["product-card__image"]} product-card-image="true">
        {url !== "" ? (
          <Image
            src={url ?? "/"}
            alt={alt ?? "Main product image"}
            width={1000}
            height={1250}
            sizes={"(min-width: 768px) 30vw, 50vw"}
          />
        ) : (
          <div
            style={{
              backgroundColor: "var(--color-primary-20)",
              height: "100%"
            }}
          />
        )}
        {secondImage?.uri && (
          <Image
            className={styles["second-image"]}
            src={secondImage.uri}
            width={1000}
            height={1250}
            alt={secondImage.alt ?? "Second product image"}
            sizes={"(min-width: 768px) 30vw, 50vw"}
          />
        )}

        {children}
      </div>
    </div>
  );
};

export default Gallery;
